module.exports = __webpack_public_path__ + "static/media/ALERTA_CTM_alt.ca2d1445.svg";